export default __webpack_public_path__ + "static/media/abrl.5cdc18c0.svg";